import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { typography } from "@/styles/typography";

const FAQSection = () => {
  const faqs = [
    {
      question: "¿Cuánto cuesta implementar IA en mi negocio?",
      answer: "Depende del alcance. Una auditoría inicial para identificar oportunidades cuesta entre 300-500€. Un piloto funcional (por ejemplo, un agente de voz o automatización de emails) está en el rango de 1.500-3.000€. Una implementación completa con varios procesos automatizados va de 5.000 a 15.000€. Y el mantenimiento y soporte continuo parte desde 500€/mes. Siempre empezamos con la auditoría para que sepas exactamente qué necesitas antes de invertir más."
    },
    {
      question: "No soy técnico. ¿Puedo usar esto igualmente?",
      answer: "Sí, de hecho la mayoría de nuestros clientes no son técnicos. Trabajamos con restaurantes, clínicas dentales, consultoras, e-commerce… Nosotros nos encargamos de toda la parte técnica: configuración, integración con tus sistemas actuales y formación. Tú solo necesitas decirnos qué problemas tienes y nosotros diseñamos la solución."
    },
    {
      question: "¿En cuánto tiempo veo resultados?",
      answer: "Depende del proyecto, pero nuestros clientes ven impacto rápido. Pizzería Don Pepe recuperó su inversión en 2 meses con un agente de voz. NaturalFit aumentó ventas un 45% en 3 meses con un chatbot en WhatsApp. Consultoría Sigma ahorra 40 horas al mes en propuestas. Un piloto típico está funcionando en 2-4 semanas."
    },
    {
      question: "¿Qué diferencia hay entre las cápsulas gratuitas y contratar vuestros servicios?",
      answer: "Las cápsulas son guías prácticas para que aprendas a usar herramientas de IA por tu cuenta. Son gratuitas y puedes empezar hoy. Contratar nuestros servicios es para cuando necesitas una solución a medida, integrada con tus sistemas, con soporte continuo y resultados garantizados. Muchos clientes empiezan con las cápsulas y luego nos contratan para ir más lejos."
    },
    {
      question: "¿Qué pasa si la IA falla o da respuestas incorrectas?",
      answer: "Toda implementación incluye controles de calidad. Configuramos alertas, revisiones previas al envío y límites claros sobre lo que la IA puede hacer sola vs cuándo escala a una persona. Además, con el soporte continuo monitorizamos el rendimiento y ajustamos el sistema según los resultados reales. Nunca dejamos una IA funcionando sin supervisión."
    },
    {
      question: "¿Trabajáis solo con ciertos tipos de negocio?",
      answer: "No. Trabajamos con cualquier pyme o autónomo que tenga procesos repetitivos que consumen tiempo: atención al cliente, gestión de emails, creación de contenido, documentación, citas… En la web puedes ver ejemplos de hostelería, salud, consultoría y e-commerce, pero la metodología se adapta a cualquier sector."
    }
  ];

  return (
    <div className="space-y-8">
      <Accordion type="single" collapsible className="w-full space-y-6">
        {faqs.map((faq, index) => (
          <AccordionItem 
            key={index} 
            value={`item-${index}`}
            className="bg-white/[0.08] dark:bg-black/[0.08] rounded-2xl px-8 py-3 hover:bg-white/[0.12] dark:hover:bg-black/[0.12] transition-colors duration-300"
          >
            <AccordionTrigger className={`text-left ${typography.paragraphLarge} hover:no-underline py-8 text-white dark:text-black`}>
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className={`${typography.paragraphNormal} text-white/70 dark:text-black/70 font-light leading-relaxed pb-8`}>
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="text-center pt-8">
        <p className="text-xl md:text-2xl text-white/60 dark:text-black/60 font-light mb-4">
          ¿Tienes más preguntas?
        </p>
        <a 
          href="#contact" 
          className="text-xl md:text-2xl text-white dark:text-black font-light hover:opacity-80 transition-opacity"
        >
          Hablemos de tu proyecto →
        </a>
      </div>
    </div>
  );
};

export default FAQSection;